import React, { Fragment, useEffect, useState } from 'react'
import { Col, Container, Form, FormGroup, Input, Label, Row } from 'reactstrap'
import { Btn, H4, P } from '../AbstractElements'
import { Password } from '../Constant'
import { Link, useNavigate } from 'react-router-dom'
import { supabase } from '../lib/api'
import { updateUser } from '../lib/auth'
import { ToastContainer, toast } from 'react-toastify'

const NewPassword = () => {
	const [password, setPassword] = useState('')
	const [password2, setPassword2] = useState('')
	const [togglePassword, setTogglePassword] = useState(false)
	const [togglePassword2, setTogglePassword2] = useState(false)
	const [ready, setReady] = useState(false)
	const [submitting, setSubmitting] = useState(false)
	const navigate = useNavigate()

	useEffect(() => {
		let cancelled = false

		const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
			if (!cancelled && session) {
				setReady(true)
			}
		})

		supabase.auth.getSession().then(({ data: { session } }) => {
			if (!cancelled && session) {
				setReady(true)
			}
		})

		const timeout = setTimeout(() => {
			if (cancelled) return
			supabase.auth.getSession().then(({ data: { session } }) => {
				if (!cancelled && !session) {
					toast.error('Invalid or expired reset link. Please request a new one.')
				}
			})
		}, 2000)

		return () => {
			cancelled = true
			clearTimeout(timeout)
			subscription.unsubscribe()
		}
	}, [])

	const handleSubmit = async (e) => {
		e.preventDefault()
		if (password.length < 6) {
			toast.error('Password must be at least 6 characters.')
			return
		}
		if (password !== password2) {
			toast.error('Passwords do not match.')
			return
		}
		setSubmitting(true)
		const { error } = await updateUser(password)
		setSubmitting(false)
		if (error) {
			toast.error(error.message || 'Could not update password.')
			return
		}
		toast.success('Password updated. You can sign in now.')
		await supabase.auth.signOut()
		navigate(`${process.env.PUBLIC_URL}/login`)
	}

	return (
		<Fragment>
			<Container fluid={true} className="p-0 login-page">
				<Row>
					<Col xs="12">
						<div className="login-card">
							<div className="login-main login-tab">
								<Form className="theme-form" onSubmit={handleSubmit}>
									<H4>Set new password</H4>
									<P>Choose a new password for your account.</P>
									<FormGroup className="position-relative">
										<Label className="col-form-label">{Password}</Label>
										<div className="position-relative">
											<Input
												className="form-control"
												type={togglePassword ? 'text' : 'password'}
												autoComplete="new-password"
												value={password}
												onChange={(e) => setPassword(e.target.value)}
												disabled={!ready || submitting}
											/>
											<div className="show-hide" onClick={() => setTogglePassword(!togglePassword)}>
												<span className={togglePassword ? '' : 'show'}></span>
											</div>
										</div>
									</FormGroup>
									<FormGroup className="position-relative">
										<Label className="col-form-label">Confirm password</Label>
										<div className="position-relative">
											<Input
												className="form-control"
												type={togglePassword2 ? 'text' : 'password'}
												autoComplete="new-password"
												value={password2}
												onChange={(e) => setPassword2(e.target.value)}
												disabled={!ready || submitting}
											/>
											<div className="show-hide" onClick={() => setTogglePassword2(!togglePassword2)}>
												<span className={togglePassword2 ? '' : 'show'}></span>
											</div>
										</div>
									</FormGroup>
									<div className="position-relative form-group mb-0">
										<Btn
											attrBtn={{
												color: 'primary',
												className: 'd-block w-100 mt-2',
												type: 'submit',
												disabled: !ready || submitting
											}}
										>
											{submitting ? 'Saving…' : 'Update password'}
										</Btn>
										<P attrPara={{ className: 'text-center mt-3 mb-0' }}>
											<Link className="link" to={`${process.env.PUBLIC_URL}/login`}>
												Back to sign in
											</Link>
										</P>
									</div>
								</Form>
							</div>
						</div>
					</Col>
				</Row>
			</Container>
			<ToastContainer />
		</Fragment>
	)
}

export default NewPassword
